// Auto-generated file - DO NOT EDIT
// Generated by scripts/generate-calculator-icons.ts
// Run: npm run generate:icons

import api1183Icon from '../calculators/api1183/icon.svg'
import asmeB31gIcon from '../calculators/asmeB31g/icon.svg'
import bakeoutIcon from '../calculators/bakeout/icon.svg'
import bijlaardIcon from '../calculators/bijlaard/icon.svg'
import boilerTubeIcon from '../calculators/boilerTube/icon.svg'
import bpcIcon from '../calculators/bpc/icon.svg'
import branchIcon from '../calculators/branch/icon.svg'
import bundleSightIcon from '../calculators/bundleSight/icon.svg'
import burstPressureIcon from '../calculators/burstPressure/icon.svg'
import charpyIcon from '../calculators/charpy/icon.svg'
import cokeDrumFEAIcon from '../calculators/cokeDrumFEA/icon.svg'
import cpDesignIcon from '../calculators/cpDesign/icon.svg'
import cpDesignOffshoreIcon from '../calculators/cpDesignOffshore/icon.svg'
import creepIcon from '../calculators/creep/icon.svg'
import damageIcon from '../calculators/damage/icon.svg'
import deepThoughtIcon from '../calculators/deepThought/icon.svg'
import dentFEAIcon from '../calculators/dentFEA/icon.svg'
import exemptionIcon from '../calculators/exemption/icon.svg'
import fast2Icon from '../calculators/fast2/icon.svg'
import fatigueIcon from '../calculators/fatigue/icon.svg'
import fatigueDamageIcon from '../calculators/fatigueDamage/icon.svg'
import fatigueDataExplorerIcon from '../calculators/fatigueDataExplorer/icon.svg'
import featureIdentificationIcon from '../calculators/featureIdentification/icon.svg'
import ffsBrittleIcon from '../calculators/ffsBrittle/icon.svg'
import ffsCrackLikeIcon from '../calculators/ffsCrackLike/icon.svg'
import ffsCreepIcon from '../calculators/ffsCreep/icon.svg'
import ffsDentGougeIcon from '../calculators/ffsDentGouge/icon.svg'
import ffsFatigueIcon from '../calculators/ffsFatigue/icon.svg'
import ffsFireDamageIcon from '../calculators/ffsFireDamage/icon.svg'
import ffsFireDamageLvl1Icon from '../calculators/ffsFireDamageLvl1/icon.svg'
import ffsHydrogenIcon from '../calculators/ffsHydrogen/icon.svg'
import ffsLaminationIcon from '../calculators/ffsLamination/icon.svg'
import ffsLtaIcon from '../calculators/ffsLta/icon.svg'
import ffsMisalignmentIcon from '../calculators/ffsMisalignment/icon.svg'
import ffsPart1Icon from '../calculators/ffsPart1/icon.svg'
import ffsPart2Icon from '../calculators/ffsPart2/icon.svg'
import ffsPittingIcon from '../calculators/ffsPitting/icon.svg'
import ffsThinningIcon from '../calculators/ffsThinning/icon.svg'
import flangeIcon from '../calculators/flange/icon.svg'
import hottapIcon from '../calculators/hottap/icon.svg'
import hthaIcon from '../calculators/htha/icon.svg'
import hthaSteadyStateIcon from '../calculators/hthaSteadyState/icon.svg'
import idinterpIcon from '../calculators/idinterp/icon.svg'
import inspectionReportIcon from '../calculators/inspectionReport/icon.svg'
import insulationIcon from '../calculators/insulation/icon.svg'
import largeLTAIcon from '../calculators/largeLTA/icon.svg'
import materialExplorerIcon from '../calculators/materialExplorer/icon.svg'
import mixerIcon from '../calculators/mixer/icon.svg'
import ncpvNozzleFEAIcon from '../calculators/ncpvNozzleFEA/icon.svg'
import nozzleIcon from '../calculators/nozzle/icon.svg'
import nozzleFEAIcon from '../calculators/nozzleFEA/icon.svg'
import pipeIcon from '../calculators/pipe/icon.svg'
import pipeSpanIcon from '../calculators/pipeSpan/icon.svg'
import plausibleProfilesIcon from '../calculators/plausibleProfiles/icon.svg'
import pveliteConverterIcon from '../calculators/pveliteConverter/icon.svg'
import rainflowIcon from '../calculators/rainflow/icon.svg'
import sandmanIcon from '../calculators/sandman/icon.svg'
import shellIcon from '../calculators/shell/icon.svg'
import shutdownIcon from '../calculators/shutdown/icon.svg'
import simflexIcon from '../calculators/simflex/icon.svg'
import simflexLegacyIcon from '../calculators/simflexLegacy/icon.svg'
import simflexWorkbenchIcon from '../calculators/simflexWorkbench/icon.svg'
import smoothBarFatigueIcon from '../calculators/smoothBarFatigue/icon.svg'
import snoozeFestIcon from '../calculators/snoozeFest/icon.svg'
import sphereLegsFEAIcon from '../calculators/sphereLegsFEA/icon.svg'
import storedEnergyIcon from '../calculators/storedEnergy/icon.svg'
import tankIcon from '../calculators/tank/icon.svg'
import tankBottomOptimizationIcon from '../calculators/tankBottomOptimization/icon.svg'
import tankSettlementIcon from '../calculators/tankSettlement/icon.svg'
import tankSettlementFEAIcon from '../calculators/tankSettlementFEA/icon.svg'
import tankSightIcon from '../calculators/tankSight/icon.svg'
import tbreakIcon from '../calculators/tbreak/icon.svg'
import thermowellIcon from '../calculators/thermowell/icon.svg'
import toughnessIcon from '../calculators/toughness/icon.svg'
import vanWinkGoIcon from '../calculators/vanWinkGo/icon.svg'
import vanWinkleIcon from '../calculators/vanWinkle/icon.svg'
import weldedJointFatigueIcon from '../calculators/weldedJointFatigue/icon.svg'

const icons = {
  'api1183': api1183Icon,
  'asmeB31g': asmeB31gIcon,
  'bakeout': bakeoutIcon,
  'bijlaard': bijlaardIcon,
  'boilerTube': boilerTubeIcon,
  'bpc': bpcIcon,
  'branch': branchIcon,
  'bundleSight': bundleSightIcon,
  'burstPressure': burstPressureIcon,
  'charpy': charpyIcon,
  'cokeDrumFEA': cokeDrumFEAIcon,
  'cpDesign': cpDesignIcon,
  'cpDesignOffshore': cpDesignOffshoreIcon,
  'creep': creepIcon,
  'damage': damageIcon,
  'deepThought': deepThoughtIcon,
  'dentFEA': dentFEAIcon,
  'exemption': exemptionIcon,
  'fast2': fast2Icon,
  'fatigue': fatigueIcon,
  'fatigueDamage': fatigueDamageIcon,
  'fatigueDataExplorer': fatigueDataExplorerIcon,
  'featureIdentification': featureIdentificationIcon,
  'ffsBrittle': ffsBrittleIcon,
  'ffsCrackLike': ffsCrackLikeIcon,
  'ffsCreep': ffsCreepIcon,
  'ffsDentGouge': ffsDentGougeIcon,
  'ffsFatigue': ffsFatigueIcon,
  'ffsFireDamage': ffsFireDamageIcon,
  'ffsFireDamageLvl1': ffsFireDamageLvl1Icon,
  'ffsHydrogen': ffsHydrogenIcon,
  'ffsLamination': ffsLaminationIcon,
  'ffsLta': ffsLtaIcon,
  'ffsMisalignment': ffsMisalignmentIcon,
  'ffsPart1': ffsPart1Icon,
  'ffsPart2': ffsPart2Icon,
  'ffsPitting': ffsPittingIcon,
  'ffsThinning': ffsThinningIcon,
  'flange': flangeIcon,
  'hottap': hottapIcon,
  'htha': hthaIcon,
  'hthaSteadyState': hthaSteadyStateIcon,
  'idinterp': idinterpIcon,
  'inspectionReport': inspectionReportIcon,
  'insulation': insulationIcon,
  'largeLTA': largeLTAIcon,
  'materialExplorer': materialExplorerIcon,
  'mixer': mixerIcon,
  'ncpvNozzleFEA': ncpvNozzleFEAIcon,
  'nozzle': nozzleIcon,
  'nozzleFEA': nozzleFEAIcon,
  'pipe': pipeIcon,
  'pipeSpan': pipeSpanIcon,
  'plausibleProfiles': plausibleProfilesIcon,
  'pveliteConverter': pveliteConverterIcon,
  'rainflow': rainflowIcon,
  'sandman': sandmanIcon,
  'shell': shellIcon,
  'shutdown': shutdownIcon,
  'simflex': simflexIcon,
  'simflexLegacy': simflexLegacyIcon,
  'simflexWorkbench': simflexWorkbenchIcon,
  'smoothBarFatigue': smoothBarFatigueIcon,
  'snoozeFest': snoozeFestIcon,
  'sphereLegsFEA': sphereLegsFEAIcon,
  'storedEnergy': storedEnergyIcon,
  'tank': tankIcon,
  'tankBottomOptimization': tankBottomOptimizationIcon,
  'tankSettlement': tankSettlementIcon,
  'tankSettlementFEA': tankSettlementFEAIcon,
  'tankSight': tankSightIcon,
  'tbreak': tbreakIcon,
  'thermowell': thermowellIcon,
  'toughness': toughnessIcon,
  'vanWinkGo': vanWinkGoIcon,
  'vanWinkle': vanWinkleIcon,
  'weldedJointFatigue': weldedJointFatigueIcon,
}

export default icons
